import { readStoredLanguage, writeStoredLanguage } from "@/lib/language";
import { useCallback, useEffect, useState } from "react";

/**
 * Per-token guest language. Backed by localStorage (so a refresh keeps the
 * choice) and exposed as a tiny hook — each guest page is scoped to one token.
 * Re-syncs if `token` ever changes without a remount.
 */
export function useGuestLanguage(token: string) {
  const [lang, setLangState] = useState<string | null>(() => readStoredLanguage(token));

  useEffect(() => {
    setLangState(readStoredLanguage(token));
  }, [token]);

  const setLang = useCallback(
    (next: string) => {
      writeStoredLanguage(token, next);
      setLangState(next);
    },
    [token]
  );

  return { lang, setLang };
}
